import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const majorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMajor: builder.query({
      query: ({ id }) => ({
        url: `major/${id}`,
      }),
      providesTags: ["Major"],
    }),
    getMajors: builder.query({
      query: () => ({
        url: `major?query=all`,
      }),
      providesTags: ["MajorAll"],
    }),
    getMajorsPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `major?${query}`,
        };
      },
      providesTags: ["Majors"],
    }),

    addMajor: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `major`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Major added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Majors", "MajorAll"],
    }),

    deleteMajor: builder.mutation({
      query: ({ id }) => ({
        url: `major/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: "false",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Major successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Major", "Majors", "MajorAll"],
    }),

    updateMajor: builder.mutation({
      query: ({ id, values }) => ({
        url: `major/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Major updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Major", "Majors", "MajorAll"],
    }),
    importMajors: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `major/import`,
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Majors imported successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["Majors", "MajorAll"],
    }),
  }),
});

export const {
  useGetMajorQuery,
  useGetMajorsQuery,
  useAddMajorMutation,
  useDeleteMajorMutation,
  useUpdateMajorMutation,
  useGetMajorsPaginatedQuery,
  useImportMajorsMutation,
} = majorApi;

